import { Menu } from '@lib/api';
import { MenuValue } from '@stores/menus/types';

export function fromBranchMenusResponseToMenus(response: Menu[]): MenuValue[] {
  return response.map((item) => ({
    uuid: item.menuUUID,
    name: {
      ar: item.nameAr,
      en: item.nameEn,
    },
  }));
}
